<i18n>
zh:
    repairPhone: 报修电话
    stationmaster: 站长
    phone: 电话
    jurisdiction: 管辖范围
    address: 地址
ru:
    repairPhone: Ремонтный телефон
    stationmaster: Начальник станц
    phone: телефон
    jurisdiction: Юрисдикция
    address: адрес
</i18n>
<template>
    <div class="repair_detail list_wrap_mobile">
        <template v-if="!loading">
            <div class="title_en" v-if="detail.en_name">{{detail.en_name}}</div>
            <div class="content_title">{{detail.name}}</div>
            <template v-if="detail.list && detail.list.length > 0">
                <div class="phone">{{$t('repairPhone')}}：{{detail.phone}}</div>
                <div class="list_wrap">
                    <div class="list list1">
                        <template v-for="item in detail.list">
                            <div class="item" :key="item.id">
                                <p class="name">{{item.station_name}}</p>
                                <p class="text">{{$t('stationmaster')}}：{{item.head_name}} {{$t('phone')}}：{{item.head_phone}}</p>
                                <p class="text" v-if="item.scope">{{$t('jurisdiction')}}：{{item.scope}}</p>
                            </div>
                        </template>
                    </div>
                    <div class="list list2">
                        <template v-for="item in detail.list">
                            <div class="item" :key="item.id">
                                <p class="name">{{item.station_name}}</p>
                                <p class="text">{{$t('stationmaster')}}：{{item.head_name}} {{$t('phone')}}：{{item.head_phone}}</p>
                                <p class="text" v-if="item.scope">{{$t('jurisdiction')}}：{{item.scope}}</p>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
            <div class="list" v-else>
                <div class="item">
                    <p class="name">{{detail.name}}</p>
                    <p class="text">{{$t('address')}}：{{detail.address}}</p>
                </div>
            </div>
            <!-- <div v-else class="nothing">{{$t('nothing')}}</div> -->
        </template>
        <div v-else class="loading"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "repairDetail",
    data() {
        return {
            loading: false,
            detail: {},
        };
    },
    computed: {
        ...mapState(['isPhone'])
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {
        '$route.params.listId': {
            handler: 'getData',
            immediate: true
        }
    },
    methods: {
        getData(val){
            this.loading = true;
            this.detail = {};
            this.$store.dispatch('getRepairDetail', {id: val}).then((result)=>{
                this.detail = result;
                this.loading = false;
            });
        }
    },
};
</script>

<style scoped lang="scss">
.repair_detail{
    width: 866px;
    min-height: 1190px;
    margin-left: 56px;
    background: url('~@/assets/images/grbg.jpg') no-repeat;
    background-size: 100% 100%;
    padding: 0 0 20px 45px;
    .content_title{
        background-image: url('~@/assets/images/1_18.png');
        padding-left: 35px;
        margin: 20px 0;
        border: none;
        font-size: 24px;
    }
    .title_en{
        font-family: "宋体";
        font-weight: bold;
        font-size: 56px;
        color: #dce1e5;
        margin-top: 30px;
    }
    .phone{
        font-size: 14px;
        color: #2e3a4c;
        line-height: 3;
        margin: -30px 0 30px;
    }
    .list_wrap{
        display: flex;
        .list{
            margin-right: 20px;
        }
    }
    .list{
        .item{
            width: 386px;
            border: 1px solid #f4efe9;
            background: #faf6f0;
            padding: 25px;
            margin-bottom: 50px;
            line-height: 2;
            .name{
                font-size: 18px;
            }
            .text{
                font-size: 12px;
                color: #858585;
                margin-bottom: 5px;
            }
        }
        &.list1{
            .item{
                &:nth-of-type(2n){
                    display: none;
                }
            }
        }
        &.list2{
            .item{
                &:nth-of-type(2n-1){
                    display: none;
                }
            }
        }
    }
    @media only screen and (max-width: 1024px) {
        width: 100%;
        height: auto;
        min-height: auto;
        margin: 0;
        background: none;
        padding: 0;
        border: 1px solid #e8eaed;
        border-radius: .1rem;
        .content_title{
            background: none;
            border-bottom: 1px solid #e8eaed;
            height: 1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 .3rem;
            font-size: .36rem;
            color: #1953b3;
            font-weight: bold;
            margin: 0;
        }
        .title_en{
            display: none;
        }
        .phone{
            display: none;
        }
        .list{
            .item{
                width: 100%;
                padding: .2rem;
                margin-bottom: 0;
                background: none;
                border: none;
                border-bottom: 1px solid #e8eaed;
                &:last-child{
                    border-bottom: none;
                }
                .name{
                    font-size: .24rem;
                }
                .text{
                    font-size: .24rem;
                }
            }
            &.list1{
                .item{
                    &:nth-of-type(2n){
                        display: block;
                    }
                }
            }
            &.list2{
                display: none;
            }
        }
    }
}
</style>